<script lang="ts">
  import InputNumber from "primevue/inputnumber";
  import { useField } from "vee-validate";

  InputNumber.components.InputText.compatConfig = {
    MODE: 3,
  };

  InputNumber.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };

  export default {
    components: { InputNumber },
    props: {
      name: {
        type: String,
        default: "",
      },
      mode: {
        type: String,
        default: "decimal",
      },
      currency: {
        type: String,
        default: "EUR",
      },
      locale: {
        type: String,
        default: "nl-BE",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      prefix: {
        type: String,
        default: "",
      },
      inputId: {
        type: String,
        default: undefined,
      },
      class: {
        type: String,
        default: "",
      },
      maxFractionDigits: {
        type: Number,
        default: undefined,
      },
      minFractionDigits: {
        type: Number,
        default: undefined,
      },
      max: {
        type: Number,
        default: undefined,
      },
      min: {
        type: Number,
        default: undefined,
      },
    },
    setup(props: any) {
      const { value: localValue, errorMessage, meta, handleBlur: fieldBlur, setValue } = useField<number>(() => props.name);

      return {
        localValue,
        errorMessage,
        meta,
        fieldBlur,
        setValue,
      };
    },
  };
</script>

<template>
  <InputNumber v-bind="$props" v-model="localValue" :invalid="!!errorMessage" />
</template>
